<template>
    <div>
        <v-row>
            <v-col cols="12">
                <div class="headline">Unternehmen</div>
                <v-card>
                    <v-card-title>
                      <v-spacer></v-spacer>
                        <v-text-field
                                v-model="search"
                                append-icon="far fa-search"
                                label="Suchen"
                                single-line
                                hide-details
                        ></v-text-field>
                    </v-card-title>
                    <v-data-table
                            :headers="tables.companies.header"
                            :items="companies"
                            :search="search"
                            class="mb-4"
                            no-data-text="Keine Unternehmen vorhanden"
                            :items-per-page="15"
                      >
                      <template v-slot:item.action="{ item }">
                        <v-btn icon class="mx-0" @click="editItem(item)">
                          <v-icon>far fa-edit</v-icon>
                        </v-btn>
                        <v-btn icon class="mx-0" @click="deleteItem(item)">
                          <v-icon>far fa-trash</v-icon>
                        </v-btn>
                      </template>
                    </v-data-table>
                </v-card>
              <v-card-actions>
                <v-btn color="primary" dark class="mb-2" @click="editItem(defaultItem)">Neues Unternehmen</v-btn>
              </v-card-actions>
            </v-col>
        </v-row>
        <v-dialog v-model="dialog" max-width="500px" persistent>
            <v-card>
                <v-card-title>
                    <span class="headline" v-if="isNewElement">Neues Unternehmen</span>
                    <span class="headline" v-else>Unternehmen bearbeiten</span>
                </v-card-title>
                <v-card-text>

                        <v-row>
                            <v-col cols="12">
                                <v-text-field label="Name" v-model="editedItem.name"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-autocomplete
                                        :items="districts"
                                        item-text="cityAndDistrict"
                                        item-value="id"
                                        v-model="editedItem.district"
                                        label="Gemeinde"
                                        no-data-text="Keine Gemeinde vorhanden"
                                >
                                    <template slot="item" slot-scope="data">
                                        {{ data.item.cityAndDistrict }}
                                    </template>
                                    <template slot="selection" slot-scope="data">
                                        {{ data.item.cityAndDistrict }}
                                    </template>
                                </v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="8">
                                <v-autocomplete
                                        :items="possibleStreets"
                                        item-text="name"
                                        item-value="id"
                                        v-model="editedItem.street"
                                        label="Straße"
                                        no-data-text="Keine Straße vorhanden"
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="4">
                                <v-text-field label="Hausnummer" v-model="editedItem.streetNumber"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-textarea auto-grow rows="3" label="Kommentar" v-model="editedItem.comment"></v-textarea>
                            </v-col>
                        </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click.native="close">Abbrechen</v-btn>
                    <v-btn text color="primary" @click.native="save">Speichern</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
  name: 'Companies',
  computed: {
    cities () {
      return this.$store.state.cities.all
    },
    districts () {
      return this.$store.state.districts.all
    },
    streets () {
      return this.$store.state.streets.all
    },
    companies () {
      return this.$store.state.companies.all
    },
    isNewElement () {
      return this.editedItem.id === 0
    },
    possibleStreets () {
      if (this.editedItem.district > 0) {
        let streets = []
        this.$store.state.streets.all.find(function (item) {
          if (item.district === this.editedItem.district) {
            streets.push(item)
          }
        }, this)
        return streets
      }
      return []
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    }
  },
  data: () => ({
    dialog: false,
    editedIndex: -1,
    editedItem: {
      id: 0,
      city: 0,
      district: 0,
      street: 0,
      name: '',
      comment: ''
    },
    defaultItem: {
      id: 0,
      city: 0,
      district: 0,
      street: 0,
      name: '',
      comment: ''
    },
    search: '',
    tables: {
      companies: {
        header: [
          {text: 'Name', value: 'name'},
          {text: 'Straße', value: 'streetName'},
          {text: 'Hausnummer', value: 'streetNumber'},
          {text: 'Ort', value: 'cityName'},
          {text: 'Ortsteil', value: 'districtName'},
          {text: 'Aktionen', sortable: false, value: 'action'}
        ]
      }
    }
  }),
  methods: {
    editItem (item) {
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    close () {
      this.dialog = false
      this.editedItem = Object.assign({}, this.defaultItem)
    },
    save () {
      if (this.isNewElement) {
        this.$store.commit('addCompany', this.editedItem)
      } else {
        this.$store.commit('updateCompany', this.editedItem)
      }
      this.close()
    },
    deleteItem (item) {
      this.$store.commit('delCompany', item)
    },
    getCity (id) {
      return this.$store.state.cities.all.find(element => element.id === id)
    }
  }
}
</script>

<style scoped lang="scss">
    @import "../scss/settings";
</style>



// WEBPACK FOOTER //
// src/components/Companies.vue